module.exports = __webpack_public_path__ + "img/FR16275.53914d9e.png";